import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, unref as _unref, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@assets/emoji_nobody.png'
import _imports_1 from '@assets/emoji_robot.png'
import _imports_2 from '@assets/people_black_24dp.svg'
import _imports_3 from '@assets/icon_robot.svg'
import _imports_4 from '@assets/icon_settings.svg'


const _withScopeId = n => (_pushScopeId("data-v-1664917c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "modal-overlay"
}
const _hoisted_2 = { class: "modal" }
const _hoisted_3 = { class: "modal-header" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "알림", -1))
const _hoisted_5 = { class: "modal_close" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-content" }, [
  /*#__PURE__*/_createElementVNode("div", null, "현재 나의 음성을 등록하지 않아 채팅에 참여할 수 없습니다."),
  /*#__PURE__*/_createElementVNode("div", null, "음성 등록으로 이동하시겠습니까?")
], -1))
const _hoisted_7 = { class: "wrap_button" }
const _hoisted_8 = {
  key: 1,
  class: "modal-overlay"
}
const _hoisted_9 = { class: "modal" }
const _hoisted_10 = { class: "modal-header" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "알림", -1))
const _hoisted_12 = { class: "modal_close" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-content" }, " 채팅방으로 초대하시겠습니까? ", -1))
const _hoisted_14 = { class: "wrap_button" }
const _hoisted_15 = { class: "wrap_layout" }
const _hoisted_16 = { class: "side_menu" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, " 커스텀보이스 채팅 BETA ", -1))
const _hoisted_18 = ["src"]
const _hoisted_19 = {
  key: 1,
  class: "my_picture",
  src: _imports_0
}
const _hoisted_20 = { class: "profile_info" }
const _hoisted_21 = { class: "additional_info" }
const _hoisted_22 = { key: 0 }
const _hoisted_23 = { class: "wrap_search" }
const _hoisted_24 = { class: "search-bar" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "wrap_friend_list" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "talk_title" }, " 다른 사용자와 대화해보세요! ")
], -1))
const _hoisted_26 = {
  key: 0,
  class: "no_user"
}
const _hoisted_27 = {
  key: 1,
  class: "scroll wrap_friend"
}
const _hoisted_28 = ["onClick"]
const _hoisted_29 = ["src"]
const _hoisted_30 = {
  key: 1,
  class: "other_picture",
  src: _imports_0
}
const _hoisted_31 = { class: "other_profile_info" }
const _hoisted_32 = { key: 1 }
const _hoisted_33 = { class: "wrap_search" }
const _hoisted_34 = { class: "search-bar" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "wrap_friend_list" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "talk_title" }, " Chat GPT 아바타와 대화해보세요! ")
], -1))
const _hoisted_36 = { class: "scroll wrap_friend" }
const _hoisted_37 = ["onClick"]
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "other_picture",
    src: _imports_1
  })
], -1))
const _hoisted_39 = { class: "other_profile_info" }
const _hoisted_40 = { class: "other_additional_info" }
const _hoisted_41 = { key: 2 }
const _hoisted_42 = { class: "chevron-container" }
const _hoisted_43 = { class: "chevron-container" }
const _hoisted_44 = { class: "chevron-container" }
const _hoisted_45 = { class: "chevron-container" }
const _hoisted_46 = { class: "chevron-container" }
const _hoisted_47 = { class: "chevron-container" }
const _hoisted_48 = { class: "chevron-container" }
const _hoisted_49 = { class: "chevron-container" }
const _hoisted_50 = { key: 3 }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "balloon" }, " 아바타와도 대화할 수 있어요! ", -1))
const _hoisted_52 = [
  _hoisted_51
]
const _hoisted_53 = { class: "tabbar" }
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "tabbar_icon",
  src: _imports_2
}, null, -1))
const _hoisted_55 = [
  _hoisted_54
]
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "tabbar_icon",
  src: _imports_3
}, null, -1))
const _hoisted_57 = [
  _hoisted_56
]
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "tabbar_icon",
  src: _imports_4
}, null, -1))
const _hoisted_59 = [
  _hoisted_58
]
const _hoisted_60 = { class: "main_screen" }

import {
  ref,
  onMounted,
  onUnmounted,
  computed,
} from 'vue';
import type { SelectProps } from 'ant-design-vue';
import {
  iAvatar,
  iUserRoom,
} from '@interface/chat';
import { useWebSocketStore } from '../stores/storeWebSocket';
import { useAvatarStore } from '../stores/storeAvatar';
import {
  tabStore,
  userStore,
  tutorialStore,
} from '../stores/storeAuth';
import {
  deleteLocalStorage,
  deleteStorage,
} from '@utils/storageUtils';
import { pushPage } from '@utils/route.helper';
import { routeHelper } from '@utils';
import router from '@router';
import { errorType } from '@interface/error';
import {
  getUserList,
  getSignedUserInfo,
  requestGetAvatarList,
  getAvatarDetail,
} from '@apis/voicechat';


export default /*#__PURE__*/_defineComponent({
  __name: 'MainDesktop',
  setup(__props) {

const { pushQueryPage } = routeHelper;
const userData = userStore();
const client = useWebSocketStore();
const avatarStore = useAvatarStore();
const tutorialData = tutorialStore();
const tabData = tabStore();
const searchUser = ref('');
const searchAvatar = ref('');
const roomInformation = ref();
const showInviteModal = ref(false);
const closeInviteModal = () => {
  showInviteModal.value = false;
};
const isAvatarTutorialInfo = ref(false);

const isTutorial = () => {
  if (tutorialData.isAvatarTutorial) {
    isAvatarTutorialInfo.value = true;
  } else {
    isAvatarTutorialInfo.value = false;
  }
};

// eslint-disable-next-line camelcase, arrow-body-style
const isAnimal = (profileUrl: string, animals: string[]) => {
  return profileUrl && animals.some((animal) => profileUrl.includes(animal));
};

const currentSettingAvatar = computed(() => avatarStore.settingSelectedAvatarId);

const joinChatRoom = (roomInfo: iUserRoom) => {
  console.log(roomInfo);
  closeInviteModal();
  if (roomInfo.roomId && roomInfo.isActive) {
    // 채팅룸으로 이동 (조인 되어 있는 상태)
    console.log('joinChatRoom: 채팅룸으로 이동');
    client.joinChatRoom(roomInfo.roomId);

    console.log('roomId:', roomInfo.roomId);
    router.push({
      name: 'chatUser',
      params: { id: roomInfo.roomId },
    });
  }
  if (roomInfo.roomId && !roomInfo.isActive) {
    // 채팅룸 조인
    console.log('joinChatRoom: 채팅룸 조인 토큰');
    client.sendToken({
      event: 'JOIN_ROOM',
      roomId: roomInfo.roomId,
      data: { user_id: client.sender },
    });
  }
  if (!roomInfo.roomId && !roomInfo.isActive) {
    console.log('1️⃣joinChatRoom: 채팅룸 만들기 토큰', roomInfo.userId, client.sender);
    client.sendToken({
      event: 'CREATE_ROOM',
      roomId: '',
      data: {
        user_list: [
          client.sender,
          roomInfo.userId,
        ],
      },
    });
  }
};
const changeTab = (tab: string) => {
  tabData.tabName = tab;
  if (tabData.tabName !== 'avatar') {
    searchAvatar.value = '';
    tutorialData.isAvatarTutorial = false;
    isTutorial();
  }
};
const currentMenu = ref('');
const selectCurrentMenu = (value: string) => {
  currentMenu.value = value;
  pushPage(`${value}`);
};

const confirm = () => {
  joinChatRoom(roomInformation.value);
};

const openInviteModal = (roomInfo: iUserRoom, isActive: boolean) => {
  if (isActive) {
    console.log('go to room');
    joinChatRoom(roomInfo);
  } else {
    showInviteModal.value = true;
    roomInformation.value = roomInfo;
  }
};

const userList = ref<any[]>([]);
const userRoomList = computed(() => client.activeUserRooms);
const avatarList = ref<iAvatar[]>([]);

const getUser = async () => {
  const result = await getUserList();
  userList.value = result.data.users;
};

const userDetail = ref<any>({});
const getUserDetail = async () => {
  const result = await getSignedUserInfo();
  userDetail.value = result.data;
  console.log(userDetail.value);
};

const persona = ref('');
const personaList = ref<SelectProps['options']>([{
  value: '',
  label: '--- 선택 ---',
}]);

const selectedAvatarDetail = ref<any[]>([]);
const getSelectedAvatar = async (avatarId: number) => {
  const result = await getAvatarDetail(avatarId);
  selectedAvatarDetail.value = result.data;
  console.log('selected avatar detail', selectedAvatarDetail.value);
};

// const personaHandleChange = async () => {
//   console.log(persona.value);
//   const result = getSelectedAvatar(persona.value);
//   avatarStore.chooseSettingAvatar(persona.value);
// };

const getAvatarList = async () => {
  const result = await requestGetAvatarList();
  avatarList.value = result.data.avatars;
};

// avatar 불러와서 셀렉트에 추가
const getAvatar = async () => {
  try {
    const result = await requestGetAvatarList(); // Corrected function name
    result.data.avatars.forEach((res: any) => {
      const temp = {
        value: res.id,
        label: res.name,
      };
      personaList.value.push(temp);
    });
  } catch (error) {
    console.log(error);
  }
};

const chooseAvatar = (avatarInfo: iAvatar) => {
  avatarStore.chooseAvatar(avatarInfo, userDetail.value.user_id);
  pushQueryPage('chatAvatar', avatarInfo.id.toString());
};

// const requestSendToken = async () => {
//   const data = {
//     sender: userDetail.value.user_id,
//     event: 'ACTIVE_USERS',
//     roomId: 0,
//     data: {},
//   };
//   try {
//     await client.sendToken(data);
//   } catch (e) {
//     console.log(e);
//   }
// };
const handleInput = (event: any) => {
  searchAvatar.value = event.target.value;
};

const handleSearchUserInput = (event: any) => {
  searchUser.value = event.target.value;
};

const filteredUserRoomList = computed(() => {
  const keyword = searchUser.value.toLowerCase();
  return userRoomList.value.filter((room) => room.nickName.toLowerCase().includes(keyword));
});

const filteredAvatarList = computed(() => {
  const keyword = searchAvatar.value.toLowerCase();
  return avatarList.value.filter((avatar) => avatar.name.toLowerCase().includes(keyword));
});
const connectWs = async () => {
  try {
    client.connectWebSocket(userDetail.value.user_id);
  } catch (e) {
    console.log(e);
  }
};

// const goSignOut = () => {
//   pushPage('login');
//   tabData.tabName = 'users';
// };

const goSignOut = () => {
  try {
    tabData.tabName = 'users';
    deleteStorage('accessToken');
    deleteStorage('currentRoomInfo');
    deleteStorage('userId');
    deleteStorage('client.currentRoomInfo');
    deleteLocalStorage('accessToken');
    deleteLocalStorage('currentRoomInfo');
    deleteLocalStorage('userId');
    deleteLocalStorage('client.currentRoomInfo');
    userData.$reset();
    client.resetWebSocketStore();
    pushPage('login');
    console.log(client.currentRoomInfo, 'room info<--------------');
  } catch (error) {
    console.log(error);
  }
};
const isHasSpeakerModal = ref(false);
const closeHasSpeakerModal = () => {
  isHasSpeakerModal.value = false;
};
const openHasSpeakerModal = () => {
  isHasSpeakerModal.value = true;
};

const goCustomVoice = async () => {
  await closeHasSpeakerModal();
  pushPage('customVoiceRead');
};

onMounted(async () => {
  await isTutorial();
  await getUser();
  await getUserDetail();
  await getAvatarList();
  await connectWs();
  await getAvatar();
  if (!userDetail.value.hasSpeaker) {
    await openHasSpeakerModal();
  }
});

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (isHasSpeakerModal.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _hoisted_4,
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_font_awesome_icon, {
                  icon: "fa-solid fa-xmark",
                  onClick: closeHasSpeakerModal
                })
              ])
            ]),
            _hoisted_6,
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", {
                class: "modal_cancel",
                onClick: closeHasSpeakerModal
              }, " 나중에 하기 "),
              _createElementVNode("div", {
                class: "button_okay",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (goCustomVoice()))
              }, " 이동하기 ")
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (showInviteModal.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _hoisted_11,
              _createElementVNode("div", _hoisted_12, [
                _createVNode(_component_font_awesome_icon, {
                  icon: "fa-solid fa-xmark",
                  onClick: closeInviteModal
                })
              ])
            ]),
            _hoisted_13,
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", {
                class: "modal_cancel",
                onClick: closeInviteModal
              }, " 취소 "),
              _createElementVNode("div", {
                class: "button_okay",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (confirm()))
              }, " 초대 ")
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_15, [
      _createElementVNode("div", _hoisted_16, [
        _hoisted_17,
        _createElementVNode("div", {
          class: "my_profile",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(pushPage)('myInfo')))
        }, [
          _createElementVNode("div", null, [
            (isAnimal(userDetail.value.profile_url, ['fox', 'shark', 'tiger', 'koala', 'bear', 'unicorn', 'lion', 'dog']))
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  class: "my_picture",
                  src: require(`@assets/${userDetail.value.profile_url}`),
                  alt: "Profile Picture"
                }, null, 8, _hoisted_18))
              : (_openBlock(), _createElementBlock("img", _hoisted_19))
          ]),
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("div", null, _toDisplayString(userDetail.value.nick_name), 1),
            _createElementVNode("div", _hoisted_21, " (" + _toDisplayString(userDetail.value.user_id) + ") ", 1)
          ])
        ]),
        (_unref(tabData).tabName === 'users')
          ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("input", {
                    type: "text",
                    class: "search-input",
                    placeholder: "Search",
                    onInput: handleSearchUserInput
                  }, null, 32)
                ])
              ]),
              _hoisted_25,
              (filteredUserRoomList.value.length == 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_26, " 접속한 사용자가 없습니다. "))
                : (_openBlock(), _createElementBlock("div", _hoisted_27, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredUserRoomList.value, (room, index) => {
                      return (_openBlock(), _createElementBlock("div", { key: index }, [
                        _createElementVNode("div", {
                          class: "other_profile",
                          onClick: ($event: any) => (openInviteModal(room, room.isActive))
                        }, [
                          _createElementVNode("div", null, [
                            (isAnimal(room.profileUrl, ['fox', 'shark', 'tiger', 'koala', 'bear', 'unicorn', 'lion', 'dog']))
                              ? (_openBlock(), _createElementBlock("img", {
                                  key: 0,
                                  class: "other_picture",
                                  src: require(`@assets/${room.profileUrl}`),
                                  alt: "Profile Picture"
                                }, null, 8, _hoisted_29))
                              : (_openBlock(), _createElementBlock("img", _hoisted_30))
                          ]),
                          _createElementVNode("div", _hoisted_31, [
                            _createElementVNode("div", null, _toDisplayString(room.nickName !== '' ? room.nickName : '닉네임없음'), 1)
                          ]),
                          _createElementVNode("div", null, [
                            _createElementVNode("div", {
                              class: _normalizeClass({ 'dot': true, 'active-dot': room.isActive, 'inactive-dot': !room.isActive })
                            }, null, 2)
                          ])
                        ], 8, _hoisted_28)
                      ]))
                    }), 128))
                  ]))
            ]))
          : _createCommentVNode("", true),
        (_unref(tabData).tabName === 'avatar')
          ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
              _createElementVNode("div", _hoisted_33, [
                _createElementVNode("div", _hoisted_34, [
                  _createElementVNode("input", {
                    type: "text",
                    class: "search-input",
                    placeholder: "Search",
                    onInput: handleInput
                  }, null, 32)
                ])
              ]),
              _hoisted_35,
              _createElementVNode("div", _hoisted_36, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredAvatarList.value, (avatar, index) => {
                  return (_openBlock(), _createElementBlock("div", { key: index }, [
                    _createElementVNode("div", {
                      class: "other_profile",
                      onClick: ($event: any) => (chooseAvatar(avatar))
                    }, [
                      _hoisted_38,
                      _createElementVNode("div", _hoisted_39, [
                        _createElementVNode("div", null, _toDisplayString(avatar.name), 1),
                        _createElementVNode("div", _hoisted_40, _toDisplayString(avatar.topic), 1)
                      ])
                    ], 8, _hoisted_37)
                  ]))
                }), 128))
              ])
            ]))
          : _createCommentVNode("", true),
        (_unref(tabData).tabName === 'settings')
          ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
              _createElementVNode("ul", null, [
                (userDetail.value.user_id === 'develop')
                  ? (_openBlock(), _createElementBlock("li", {
                      key: 0,
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (selectCurrentMenu('personaChat')))
                    }, [
                      _createVNode(_component_font_awesome_icon, {
                        class: "icon_menu sky",
                        icon: "fa-solid fa-pen-to-square"
                      }),
                      _createTextVNode("아바타 페르소나 생성 "),
                      _createElementVNode("div", _hoisted_42, [
                        _createVNode(_component_font_awesome_icon, {
                          class: "chevron_right",
                          icon: "fa-solid fa-chevron-right"
                        })
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (userDetail.value.user_id === 'develop')
                  ? (_openBlock(), _createElementBlock("li", {
                      key: 1,
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (selectCurrentMenu('personaEdit')))
                    }, [
                      _createVNode(_component_font_awesome_icon, {
                        class: "icon_menu red",
                        icon: "fa-solid fa-pen"
                      }),
                      _createTextVNode("아바타 페르소나 수정 "),
                      _createElementVNode("div", _hoisted_43, [
                        _createVNode(_component_font_awesome_icon, {
                          class: "chevron_right",
                          icon: "fa-solid fa-chevron-right"
                        })
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (userDetail.value.user_id == 'develop')
                  ? (_openBlock(), _createElementBlock("li", {
                      key: 2,
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (selectCurrentMenu('customVoiceLearning')))
                    }, [
                      _createVNode(_component_font_awesome_icon, {
                        class: "icon_menu orange",
                        icon: "fa-solid fa-microphone"
                      }),
                      _createTextVNode("아바타 커스텀보이스 "),
                      _createElementVNode("div", _hoisted_44, [
                        _createVNode(_component_font_awesome_icon, {
                          class: "chevron_right",
                          icon: "fa-solid fa-chevron-right"
                        })
                      ])
                    ]))
                  : (_openBlock(), _createElementBlock("li", {
                      key: 3,
                      onClick: _cache[6] || (_cache[6] = ($event: any) => (selectCurrentMenu('customVoiceRead')))
                    }, [
                      _createVNode(_component_font_awesome_icon, {
                        class: "icon_menu orange",
                        icon: "fa-solid fa-microphone"
                      }),
                      _createTextVNode("나의 커스텀보이스 "),
                      _createElementVNode("div", _hoisted_45, [
                        _createVNode(_component_font_awesome_icon, {
                          class: "chevron_right",
                          icon: "fa-solid fa-chevron-right"
                        })
                      ])
                    ])),
                _createElementVNode("li", {
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (selectCurrentMenu('myInfo')))
                }, [
                  _createVNode(_component_font_awesome_icon, {
                    class: "icon_menu grey",
                    icon: "fa-solid fa-user"
                  }),
                  _createTextVNode("내정보 수정 "),
                  _createElementVNode("div", _hoisted_46, [
                    _createVNode(_component_font_awesome_icon, {
                      class: "chevron_right",
                      icon: "fa-solid fa-chevron-right"
                    })
                  ])
                ]),
                (userDetail.value.user_id != 'develop')
                  ? (_openBlock(), _createElementBlock("li", {
                      key: 4,
                      onClick: _cache[8] || (_cache[8] = ($event: any) => (selectCurrentMenu('askAdmin')))
                    }, [
                      _createVNode(_component_font_awesome_icon, {
                        class: "icon_menu purple",
                        icon: "fa-solid fa-circle-question"
                      }),
                      _createTextVNode("관리자에게 문의하기 "),
                      _createElementVNode("div", _hoisted_47, [
                        _createVNode(_component_font_awesome_icon, {
                          class: "chevron_right",
                          icon: "fa-solid fa-chevron-right"
                        })
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (userDetail.value.user_id === 'develop')
                  ? (_openBlock(), _createElementBlock("li", {
                      key: 5,
                      onClick: _cache[9] || (_cache[9] = ($event: any) => (selectCurrentMenu('askBoard')))
                    }, [
                      _createVNode(_component_font_awesome_icon, {
                        class: "icon_menu purple",
                        icon: "fa-solid fa-circle-question"
                      }),
                      _createTextVNode(" 문의수신 "),
                      _createElementVNode("div", _hoisted_48, [
                        _createVNode(_component_font_awesome_icon, {
                          class: "chevron_right",
                          icon: "fa-solid fa-chevron-right"
                        })
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("li", {
                  onClick: _cache[10] || (_cache[10] = ($event: any) => (goSignOut()))
                }, [
                  _createVNode(_component_font_awesome_icon, {
                    class: "icon_menu blue",
                    icon: "fa-solid fa-right-from-bracket"
                  }),
                  _createTextVNode("로그아웃 "),
                  _createElementVNode("div", _hoisted_49, [
                    _createVNode(_component_font_awesome_icon, {
                      class: "chevron_right",
                      icon: "fa-solid fa-chevron-right"
                    })
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        (isAvatarTutorialInfo.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_50, _hoisted_52))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_53, [
          _createElementVNode("div", {
            class: _normalizeClass({ 'active-tab': _unref(tabData).tabName === 'users' }),
            onClick: _cache[11] || (_cache[11] = ($event: any) => (changeTab('users')))
          }, _hoisted_55, 2),
          _createElementVNode("div", {
            class: _normalizeClass({ 'active-tab': _unref(tabData).tabName === 'avatar' }),
            onClick: _cache[12] || (_cache[12] = ($event: any) => (changeTab('avatar')))
          }, _hoisted_57, 2),
          _createElementVNode("div", {
            class: _normalizeClass({ 'active-tab': _unref(tabData).tabName === 'settings' }),
            onClick: _cache[13] || (_cache[13] = ($event: any) => (changeTab('settings')))
          }, _hoisted_59, 2)
        ])
      ]),
      _createElementVNode("div", _hoisted_60, [
        _createVNode(_component_router_view)
      ])
    ])
  ], 64))
}
}

})